import React from "react";
import { Link } from "react-router-dom";
import { Star, ShoppingBag, Eye } from "lucide-react";
import { formatFCFA } from "../lib/constants";
import { useCart } from "../context/CartContext";

export default function ProductCard({ product }) {
  const { addItem } = useCart();
  const discount = product.old_price
    ? Math.round(((product.old_price - product.price) / product.old_price) * 100)
    : 0;

  return (
    <div className="product-card group border border-neutral-100 overflow-hidden" data-testid={`product-card-${product.slug}`}>
      <div className="img-wrap relative overflow-hidden bg-[#FBF9F4] aspect-square">
        <Link to={`/produit/${product.slug}`}>
          <img
            src={product.images?.[0]}
            alt={product.name}
            className="w-full h-full object-cover"
            loading="lazy"
          />
        </Link>

        <div className="absolute top-3 left-3 flex flex-col gap-2">
          {product.badge && (
            <span className="bg-[#0A0A0A] text-[#F4E5A1] text-[10px] uppercase tracking-widest px-3 py-1">
              {product.badge}
            </span>
          )}
          {discount > 0 && (
            <span className="bg-[#B8860B] text-white text-[10px] font-semibold px-3 py-1">
              -{discount}%
            </span>
          )}
        </div>

        {/* Quick actions */}
        <div className="absolute inset-x-0 bottom-0 p-3 flex gap-2 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
          <button
            onClick={() => addItem(product)}
            className="btn-gold flex-1 py-2.5 text-sm rounded-sm"
            data-testid={`add-to-cart-${product.slug}`}
          >
            <ShoppingBag size={16} /> Ajouter
          </button>
          <Link
            to={`/produit/${product.slug}`}
            className="btn-dark px-3 rounded-sm"
            data-testid={`quick-view-${product.slug}`}
            aria-label="Voir le produit"
          >
            <Eye size={16} />
          </Link>
        </div>
      </div>

      <div className="p-4">
        <p className="text-[11px] uppercase tracking-widest text-[#B8860B] mb-1">{product.category_name}</p>
        <Link to={`/produit/${product.slug}`}>
          <h3 className="font-display text-lg leading-snug text-[#0A0A0A] hover:text-[#B8860B] transition line-clamp-2 min-h-[3.2rem]">
            {product.name}
          </h3>
        </Link>
        <div className="flex items-center gap-1 my-2">
          {[...Array(5)].map((_, i) => (
            <Star
              key={i}
              size={13}
              className={i < Math.round(product.rating) ? "fill-[#D4AF37] text-[#D4AF37]" : "text-neutral-300"}
            />
          ))}
          <span className="text-xs text-neutral-400 ml-1">({product.reviews_count})</span>
        </div>
        <div className="flex items-baseline gap-2">
          <span className="font-display text-xl font-semibold text-[#0A0A0A]">{formatFCFA(product.price)}</span>
          {product.old_price && (
            <span className="text-sm text-neutral-400 line-through">{formatFCFA(product.old_price)}</span>
          )}
        </div>
      </div>
    </div>
  );
}
